<div class="related-records grid">
    @if (showCases) {
        <clmi-related-cases
            class="g-col-12"
            [isInactiveRecord]="isInactiveRecord"
            [entityId]="entityId"
            [entityType]="entityType"
            [showChildCases]="showChildCases"
            [showRelatedCases]="showRelatedCases"
            [showSuggestedCases]="showSuggestedCases"
            [cardsPerRow]="cardsPerRow"
        ></clmi-related-cases>
    }

    @if (showOpportunities) {
        <clmi-related-opportunities
            class="g-col-12"
            [entityId]="entityId"
            [entityType]="entityType"
            [cardsPerRow]="cardsPerRow"
            [isInactiveRecord]="isInactiveRecord"
        ></clmi-related-opportunities>
    }

    @if ((FeatureFlag.Articles | hasFeature) && showArticles) {
        <clmi-related-articles
            class="g-col-12"
            [entityId]="entityId"
            [entityType]="entityType"
            [cardsPerRow]="cardsPerRow"
            [isInactiveRecord]="isInactiveRecord"
        ></clmi-related-articles>
    }

    @if (showActivities) {
        <clmi-related-activities
            class="g-col-12"
            [entityId]="entityId"
            [entityType]="entityType"
            [cardsPerRow]="cardsPerRow"
            [isInactiveRecord]="isInactiveRecord"
        ></clmi-related-activities>
    }

    <ng-content></ng-content>
</div>
